import { render } from "./OurStorySection.vue?vue&type=template&id=39e856ec&scoped=true"
import script from "./OurStorySection.vue?vue&type=script&lang=js"
export * from "./OurStorySection.vue?vue&type=script&lang=js"

import "./OurStorySection.vue?vue&type=style&index=0&id=39e856ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e856ec"]])

export default __exports__